import Card from '@mui/material/Card';
import { CardContent } from '@mui/material';
import { makeStyles } from '@material-ui/styles';
import { getUser } from 'src/utils/Common';
import axios from 'src/utils/axios';
import React, { useEffect, useState } from 'react';
import { useHistory, useLocation } from 'react-router';
import {
  Grid,
  Table,
  TableCell,
  TableContainer,
  TableHead,
  TableBody,
  TableRow,
  Paper,
  Divider,
  TextField,
  Button,
  Backdrop,
  CircularProgress,
  Snackbar,
  TablePagination,
  Typography,
  Box,
  Tooltip,
  IconButton
} from '@material-ui/core';
import Alert from 'src/components/Alert';
import { confirmAlert } from 'react-confirm-alert';
import PlusOneIcon from '@material-ui/icons/PlusOne';
import DeleteIcon from '@material-ui/icons/Delete';
import ArrowUpward from '@material-ui/icons/ArrowUpward';
import ArrowDownward from '@material-ui/icons/ArrowDownward';
import moment from 'moment';
import { ro } from 'date-fns/esm/locale';
import { DataGrid } from '@mui/x-data-grid';

const useStyles = makeStyles(theme => ({
  root: {
    fontFamily: 'Segoe UI',
    width: '100%',
    height: '100%'
  },
  backdrop: {
    zIndex: theme.zIndex.drawer + 1,
    color: '#FFA500'
  },
  tableCell: {
    border: '1px solid #ddd',
    color: '#fff',
    backgroundColor: '#0033a0',
    align: 'center',
    cursor: 'pointer'
  },
  sortHeader: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between'
  },
  icon: {
    fontSize: '1rem'
  },
  tableHead: {
    overflowWrap: 'break-word'
  }
}));

function SarisDynamicUnit() {
  const classes = useStyles();
  const SessionUser = getUser();
  const history = useHistory();
  const [dynamicUnitData, setDynamicUnitData] = React.useState([]);
  const [loading, setLoading] = React.useState(false);
  const [uyari, setUyari] = useState(false);
  const [uyariTip, setUyariTip] = React.useState('default');
  const [pg, setpg] = React.useState(0);
  const [rpg, setrpg] = React.useState(10);
  const [unitCode, setUnitCode] = React.useState('');
  const [description, setDescription] = React.useState('');
  const [order, setOrder] = useState('asc'); // 'asc' veya 'desc'
  const [orderBy, setOrderBy] = useState('KUL_BIRIM_KODU'); // Varsayılan sıralama kolonu
  const [responseMessage, setresponseMessage] = useState({
    ErrorCode: '0',
    ErrorDescription: 'success_message'
  });

  useEffect(() => {
    handleGetSarisDynamicUnit();
  }, []);

  const handleGetSarisDynamicUnit = () => {
    setLoading(true);
    axios
      .get(`GetSarisDynamicUnit`)
      .then(response => {
        setLoading(false);
        var data = response.data;
        setDynamicUnitData(data);
      })
      .catch(error => {
        setLoading(false);
        return;
      });
  };

  const handleRequestSort = property => {
    const isAsc = orderBy === property && order === 'asc';
    setOrder(isAsc ? 'desc' : 'asc');
    setOrderBy(property);
  };

  const sortedData = [...dynamicUnitData].sort((a, b) => {
    if (a[orderBy] < b[orderBy]) {
      return order === 'asc' ? -1 : 1;
    }
    if (a[orderBy] > b[orderBy]) {
      return order === 'asc' ? 1 : -1;
    }
    return 0;
  });

  const getSortIcon = property => {
    if (orderBy === property) {
      return order === 'asc' ? (
        <ArrowUpward style={{ fontSize: '1rem' }} />
      ) : (
        <ArrowDownward style={{ fontSize: '1rem' }} />
      );
    }
    return <ArrowUpward style={{ fontSize: '1rem' }} />;
  };

  function handleChangePage(event, newpage) {
    setpg(newpage);
  }

  function handleChangeRowsPerPage(event) {
    setrpg(parseInt(event.target.value, 10));
    setpg(0);
  }
  const uyariKapat = (event, reason) => {
    if (reason === 'clickaway') {
      return;
    }
    setUyari(false);
  };

  const RouteSarisDynamicUnitDetail = row => {
    history.push(
      `/SarisDynamicUnitDetail/${row.BIRIM_KODU}/${row.KUL_BIRIM_KODU}/${row.ACIKLAMA}`
    );
  };

  const HandleInsertUnit = () => {
    if (unitCode.length > 30) {
      setresponseMessage('Birim Kodu 30 karakterden büyük olamaz !');
      setUyariTip('error');
      setUyari(true);
      return;
    }
    setLoading(true);
    axios
      .get(`SetSarisDynamicNewUnit/${unitCode}/${description}`)
      .then(response => {
        setLoading(false);
        var data = response.data;
        if (data.ErrorCode == '1000') {
          setresponseMessage(data.ErrorDescription);
          setUyariTip('error');
          setUyari(true);
          return;
        } else {
          setresponseMessage(data.ErrorDescription);
          setUyariTip('success');
          setUyari(true);
          handleGetSarisDynamicUnit();
          setUnitCode('');
          setDescription('');
          return;
        }
      })
      .catch(error => {
        setLoading(false);
        return;
      });
  };

  const deleteDynamicUnitCode = (BirimKodu, KulKodu) => {
    confirmAlert({
      message: 'Silmek istediğinizde emin misiniz?',
      buttons: [
        {
          label: 'Evet',
          onClick: () => {
            handleDeleteDynamicUnitCode(BirimKodu, KulKodu);
          }
        },
        {
          label: 'Hayır',
          onClick: () => {
            return;
          }
        }
      ]
    });
  };

  const handleDeleteDynamicUnitCode = (BirimKodu, KulKodu) => {
    setLoading(true);
    axios
      .get(`SetSarisDynamicUnitCodeDelete/${BirimKodu}/${KulKodu}`)
      .then(response => {
        setLoading(false);
        var data = response.data;
        if (data.ErrorCode == '1000') {
          setresponseMessage(data.ErrorDescription);
          setUyariTip('error');
          setUyari(true);
          return;
        } else {
          setresponseMessage(data.ErrorDescription);
          setUyariTip('success');
          setUyari(true);
          handleGetSarisDynamicUnit();
          return;
        }
      })
      .catch(error => {
        setLoading(false);
        return;
      });
  };

  const columns = [
    {
      field: 'KUL_BIRIM_KODU',
      headerName: 'Kod',
      width: 300,
      headerAlign: 'center',
      renderCell: params => (
        <span
          style={{
            textDecoration: 'underline',
            cursor: 'pointer',
            color: '#FF9800'
          }}
          onClick={() => RouteSarisDynamicUnitDetail(params.row)}
        >
          {params.row.KUL_BIRIM_KODU}
        </span>
      )
    },
    {
      field: 'ACIKLAMA',
      headerName: 'Açıklama',
      width: 700,
      headerAlign: 'center'
    },
    {
      field: 'ADSOYAD',
      headerName: 'Ekleyen Kullancı',
      width: 400,
      headerAlign: 'center'
    },
    {
      field: 'TARIH',
      headerName: 'Oluşturulma Tarihi',
      width: 400,
      headerAlign: 'center',
      sortComparator: (v1, v2) => {
        const date1 = new Date(v1).getTime();
        const date2 = new Date(v2).getTime();
        return date1 - date2;
      },
      renderCell: params => {
        return moment(params.value).format('DD/MM/YYYY HH:mm:ss');
      }
    },
    {
      field: 'Sil',
      headerAlign: 'center',
      renderCell: cellValues => {
        return (
          <Box sx={{ justifyContent: 'center', '& > :not(style)': { m: 1 } }}>
            <Tooltip title="sil">
              <IconButton>
                <DeleteIcon
                  style={{ color: '#FF9800' }}
                  onClick={() =>
                    deleteDynamicUnitCode(
                      cellValues?.row?.BIRIM_KODU,
                      cellValues?.row?.KUL_KODU
                    )
                  }
                />
              </IconButton>
            </Tooltip>
          </Box>
        );
      },
      width: 100
    }
  ];

  return (
    <>
      <Snackbar
        open={uyari}
        autoHideDuration={5000}
        onClose={uyariKapat}
        anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
      >
        <Alert
          onClose={uyariKapat}
          variant={uyariTip}
          message={responseMessage}
        ></Alert>
      </Snackbar>
      <Card>
        <Backdrop className={classes.backdrop} open={loading}>
          <CircularProgress color="inherit" />
        </Backdrop>
        <br></br>
        <br></br>
        <Grid container justifyContent="center">
          <Divider style={{ margin: '1rem' }} />
          <Typography
            align="center"
            style={{
              marginBottom: '1rem',
              color: '#FF9800',
              fontWeight: 'bold',
              fontSize: '1.2rem'
            }}
          >
            Yeni Giriş
          </Typography>
          <Grid container spacing={2}>
            <Grid item xs={3}></Grid>
            <Grid item xs={6}>
              <TextField
                fullWidth
                label="Birim"
                variant="outlined"
                size="small"
                value={unitCode}
                onChange={e => setUnitCode(e.target.value)}
              />
            </Grid>
            <Grid item xs={3}></Grid>
            <Grid item xs={3}></Grid>
            <Grid item xs={6}>
              <TextField
                fullWidth
                label="Açıklama"
                variant="outlined"
                size="small"
                multiline
                rows={4}
                value={description}
                onChange={e => setDescription(e.target.value)}
              />
            </Grid>
            <Grid item xs={3}></Grid>
            <br></br>
            <br></br>
            <Grid item xs={12}></Grid>
            <Grid item xs={3}></Grid>
            <Grid item xs={6}>
              <Button
                variant="contained"
                color="secondary"
                fullWidth
                startIcon={<PlusOneIcon />}
                onClick={() => {
                  HandleInsertUnit();
                }}
              >
                Ekle
              </Button>
            </Grid>
            <Grid item xs={3}></Grid>
          </Grid>
        </Grid>
        <br></br>
        <br></br>
        <br></br>
        <CardContent>
          <Grid item xs={12} sm={12} md={12}>
            <DataGrid
              rows={dynamicUnitData || []}
              columns={columns}
              getRowId={rows => rows.BIRIM_KODU}
              sx={{
                height: 600,
                width: '100%',
                '& .MuiDataGrid-cell': {
                  textAlign: 'center',
                  justifyContent: 'center'
                }
              }}
            />
          </Grid>
        </CardContent>
      </Card>
    </>
  );
}

export default SarisDynamicUnit;
